import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

const ProfileCard = ({ employee }) => (
  <Box
    sx={{
      border: "2px solid #2E7D32",
      borderRadius: "18px",
      p: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      minHeight: 320,
      bgcolor: "#fff",
      boxShadow: 0,
    }}
  >
      <Avatar src={employee.photo} alt={employee.name} sx={{ width: 100, height: 100, mb: 2 }} />
    <Typography fontWeight={600} fontSize={18} color="#225B27">
      {employee.name}
    </Typography>
    <Typography fontSize={14} color="#888" mb={1}>
      {employee.designation}
    </Typography>
    <Typography fontSize={13} color="#888" mb={1}>
      {employee.id}
    </Typography>
    <Typography fontWeight={500} fontSize={13} color="#225B27" mt={2} mb={0.5}>
      Contact
    </Typography>
    <Typography fontSize={13} color="#888">
      {employee.phone}
    </Typography>
    <Typography fontSize={13} color="#888">
      {employee.email}
    </Typography>
  </Box>
);

export default ProfileCard; 